import ReactSVGCore from 'react-svg';
import * as lib from '~/dependencies';

export const ReactSVG = lib.styled(ReactSVGCore)`
    font-size: 15px !important;

    .st1 {
      stroke: ${(props: { selected: boolean }) =>
        props.selected ? `#FF0000;` : `#FF0000`};
    }

    div {
        display: flex;
        height: fit-content;
    }
`;
